export const ecommerceFields: Array<string> = [
  'details.brandLabel',
  'partNumber',
  'details.partTerminology.id',
  'details.emissionCode',
  'details.quantityPerApplication',
  'details.quantityPerApplicationUom',
  'details.warrantyDistance',
  'details.warrantyDistanceUom',
  'details.warrantyTime',
  'details.warrantyTimeUom',
  'details.warrantySpecial',
  'details.warrantySpecialUom',
  'EA.dimensions.length',
  'EA.dimensions.width',
  'EA.dimensions.height',
  'EA.weights.weight',
  'EA.package_level_GTIN',
  'EA.dimensions.uom',
  'EA.weights.uom',
  'EA.quantity',
  'descriptions.DES',
  'descriptions.SHP',
  'descriptions.MKT',
  'descriptions.ASC',
  'descriptions.EXT',
  'digitalAssets',
  'attributes',
  'fitments',
];
